'use client';
import { useCtaColor } from '@dealerportal/react-helpers';
import classNames from 'classnames';
import type { FC } from 'react';

interface PillProps {
  text: string;
  backgroundColor?: 'primary' | 'neutral';
  fontColor?: string;
  visible?: boolean;
  radius?: string;
  className?: string;
}

export const Pill: FC<PillProps> = ({
  text,
  fontColor,
  backgroundColor = 'neutral',
  visible = true,
  radius,
  className,
}) => {
  const { ctaColor } = useCtaColor();

  if (!visible) return null;

  const finalBackgroundColor =
    backgroundColor === 'primary' ? ctaColor : 'white';
  const finalRadius = radius || 'ui-rounded-md';

  return (
    <div
      className={classNames(
        'ui-flex ui-items-center ui-w-22 ui-h-7 ui-px-3 ui-py-1 ui-gap-2 ui-mb-2 ui-whitespace-nowrap ui-text-xs ',
        className,
        finalRadius,
        'ui-text-gray-950 ui-text-sm ui-font-semibold ui-text-center'
      )}
      style={{
        backgroundColor: finalBackgroundColor,
        color: fontColor,
      }}
    >
      <span className={classNames('ui-font-semibold')}>{text}</span>
    </div>
  );
};

export const Pills: FC<{ pills: PillProps[]; dispatch: any }> = ({ pills }) => {
  return (
    <div className="ui-flex ui-flex-wrap ui-items-center ui-justify-between">
      <div className="ui-flex ui-flex-wrap">
        {pills.map((pill) => (
          <Pill key={pill.text} {...pill} />
        ))}
      </div>
    </div>
  );
};
